/* ============================================================
   Kitchen Center — Cross Selling JS
   assets/kc-cross-selling.js
   ============================================================ */

(function () {
  'use strict';

  var CART_ADD_URL = '/cart/add.js';
  var popupOpened  = false;

  /* ================================================================
     Carrusel sección fija
     ================================================================ */
  var fixedCurrent = 0;

  function getPerPage() {
    if (window.innerWidth < 600) return 2;
    if (window.innerWidth < 900) return 3;
    return 4;
  }

  function initFixedCarousel() {
    var track    = document.getElementById('kc-cs-track');
    var overflow = track ? track.parentElement : null;
    if (!track || !overflow) return;
    var cards   = Array.from(track.querySelectorAll('.kc-cs__card'));
    if (!cards.length) return;
    var prevBtn = document.querySelector('#kc-cross-selling .kc-cs__arrow--prev');
    var nextBtn = document.querySelector('#kc-cross-selling .kc-cs__arrow--next');
    var dotsEl  = document.getElementById('kc-cs-dots');
    var gap     = 14;

    function pp()       { return getPerPage(); }
    function maxPage()  { return Math.max(0, Math.ceil(cards.length / pp()) - 1); }
    function cardWidth(){ return (overflow.offsetWidth - gap * (pp() - 1)) / pp(); }

    function applyWidths() {
      var w = cardWidth();
      cards.forEach(function(c) { c.style.minWidth = w + 'px'; c.style.maxWidth = w + 'px'; });
    }

    function buildDots() {
      if (!dotsEl) return;
      var pages = Math.ceil(cards.length / pp());
      dotsEl.innerHTML = '';
      if (pages <= 1) return;
      for (var i = 0; i < pages; i++) {
        var d = document.createElement('button');
        d.className = 'kc-cs__dot' + (i === fixedCurrent ? ' kc-cs__dot--active' : '');
        d.dataset.page = i;
        d.addEventListener('click', function() { fixedCurrent = parseInt(this.dataset.page); update(); });
        dotsEl.appendChild(d);
      }
    }

    function update() {
      applyWidths();
      var offset = fixedCurrent * pp() * (cardWidth() + gap);
      track.style.transform = 'translateX(-' + offset + 'px)';
      if (prevBtn) prevBtn.style.opacity = fixedCurrent === 0 ? '0.35' : '1';
      if (nextBtn) nextBtn.style.opacity = fixedCurrent >= maxPage() ? '0.35' : '1';
      if (dotsEl) dotsEl.querySelectorAll('.kc-cs__dot').forEach(function(d, i) {
        d.classList.toggle('kc-cs__dot--active', i === fixedCurrent);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { if (fixedCurrent > 0) { fixedCurrent--; update(); } });
    if (nextBtn) nextBtn.addEventListener('click', function() { if (fixedCurrent < maxPage()) { fixedCurrent++; update(); } });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (fixedCurrent > maxPage()) fixedCurrent = maxPage();
        buildDots();
        update();
      }, 100);
    });

    buildDots();
    update();
  }

  /* ================================================================
     Hook al PubSub de Dawn para detectar cart:update del producto
     ================================================================ */
  function initPopupHook() {
    if (typeof window.kcOpenCsPopup !== 'function') return;

    // Método 1: PubSub de Dawn (cartUpdate event)
    // Dawn emite esto justo después de un add exitoso
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(data) {
        // Solo abrir si viene del product-form (no de nuestra sección cross-selling)
        if (data && data.source === 'product-form') {
          if (typeof window.kcOpenCsPopup === 'function') {
            window.kcOpenCsPopup();
          }
        }
      });
    } else {
      // Método 2: fallback - hookear el form submit directamente
      hookFormSubmit();
    }
  }

  function hookFormSubmit() {
    var productForm = document.querySelector('product-form');
    if (!productForm) return;

    var form = productForm.querySelector('form');
    if (!form || form._kcHooked) return;
    form._kcHooked = true;

    form.addEventListener('submit', function() {
      // Esperar a que el fetch del tema termine (~1.2s)
      setTimeout(function() {
        if (typeof window.kcOpenCsPopup === 'function') {
          window.kcOpenCsPopup();
        }
      }, 1200);
    });
  }

  /* ================================================================
     Add to cart para botones del cross-selling (sección + popup)
     ================================================================ */
  function initCsSectionCart() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.kc-cs__btn');
      if (!btn || btn.disabled) return;
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      addToCart(btn, variantId);
    });
  }

  function addToCart(btn, variantId) {
    var textEl    = btn.querySelector('.kc-cs__btn-text');
    var addedEl   = btn.querySelector('.kc-cs__btn-added');
    var loadingEl = btn.querySelector('.kc-cs__btn-loading');

    btn.disabled = true;
    if (textEl)    textEl.style.display    = 'none';
    if (loadingEl) loadingEl.style.display = 'inline';

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(res) { if (!res.ok) throw new Error('Error ' + res.status); return res.json(); })
    .then(function() {
      if (loadingEl) loadingEl.style.display = 'none';
      if (addedEl)   addedEl.style.display   = 'inline-flex';
      btn.classList.add('kc-cs__btn--added');
      openCartDrawer();
      setTimeout(function() {
        if (addedEl) addedEl.style.display = 'none';
        if (textEl)  textEl.style.display  = 'inline-flex';
        btn.classList.remove('kc-cs__btn--added');
        btn.disabled = false;
      }, 3000);
    })
    .catch(function() {
      if (loadingEl) loadingEl.style.display = 'none';
      if (textEl)    textEl.style.display    = 'inline-flex';
      btn.classList.add('kc-cs__btn--error');
      if (textEl) textEl.textContent = 'Error, reintentar';
      btn.disabled = false;
      setTimeout(function() { btn.classList.remove('kc-cs__btn--error'); }, 3000);
    });
  }

  function openCartDrawer() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
      fetch('/?section_id=cart-drawer')
        .then(function(r) { return r.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newItems = doc.querySelector('#CartDrawer-CartItems');
          var curItems = document.querySelector('#CartDrawer-CartItems');
          if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            var totalEl = document.querySelector('#totalCartValue_drawer');
            if (totalEl) totalEl.textContent = 'S/. ' + (cart.total_price / 100).toFixed(2);
            updateCartCount(cart.item_count);
            if (cartDrawerEl) cartDrawerEl.classList.remove('is-empty');
            cartDrawerEl.open();
          });
        });
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  function updateCartCount(count) {
    ['[data-cart-count]','.cart-count','#cart-count','.cart__count','[data-header-cart-quantity]'].forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) { el.textContent = count; });
    });
  }

  function init() {
    setTimeout(initFixedCarousel, 50);
    initCsSectionCart();
    // Esperar a que pubsub.js de Dawn esté cargado
    if (typeof subscribe !== 'undefined') {
      initPopupHook();
    } else {
      // Si pubsub aún no cargó, esperar un tick
      setTimeout(initPopupHook, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
